// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * The `register_surface` an installed pack form declares to supply the
 * data registry's `provenance.authorisation_basis` vocabulary. The values
 * themselves are pack-declared and never listed in `src/` (R-46).
 */
export const DATA_REGISTRY_PROVENANCE_REGISTER_SURFACE = 'data_registry_provenance';
/** The field on that form whose `options[]` are the authorisation vocabulary. */
export const DATA_REGISTRY_AUTHORISATION_BASIS_FIELD = 'authorisation_basis';
/**
 * Sprint 62.35.0 — the answers a check question may carry, besides *not
 * recorded* (`null`). Generic answer words, not instrument vocabulary: "not
 * determined" is a recorded answer — the check was made and could not settle
 * the question — and is never the same thing as `null`, which says nothing was
 * recorded at all (gate E12.5 pass 1, P1-6).
 */
export const DATA_REGISTRY_CHECK_ANSWERS = ['yes', 'no', 'not_determined'];
/**
 * Sprint 62.35.0 — the server's refusal codes for the two operator-entered
 * check members (gate E12.5 pass 1, P2-1). Declared here so the editor can
 * state each refusal in the operator's language by code (gate E12.5 pass 2,
 * P2-1) rather than relaying the server's English sentence, and so a renamed
 * code on one side is a compile error on the other.
 *
 * The future-date judgement stays the server's: "today" is the calendar date
 * in the organisation's zone, which the browser does not know.
 */
export const DATA_REGISTRY_QUALITY_REFUSAL_CODES = {
    /** `quality_verification.checked_on` is after today in the org's calendar. */
    CHECKED_ON_IN_FUTURE: 'quality_checked_on_in_future',
    /** `quality_verification.checked_by_user_id` is not a user of this organisation. */
    CHECKED_BY_NOT_FOUND: 'quality_checked_by_not_found',
};
/**
 * fix-sprint-20260925-2123 (Finding 11) — the refusal of a stale registry
 * write. Every PUT and PATCH of a registry item names the `updated_at` it read
 * (`expected_updated_at`), and the write is conditional on the stored item
 * still carrying it. When it does not, nothing is written and the server
 * answers 409 with this code, so the editor can say so in the operator's
 * language rather than relaying the server's English sentence.
 */
export const DATA_REGISTRY_WRITE_REFUSAL_CODES = {
    /** The item changed after the caller read it; the write was not made. */
    CONFLICT: 'DATA_REGISTRY_ITEM_CONFLICT',
};
/**
 * fix-sprint-20261003-0625 F19 — why an import did not apply a value, as a code
 * the client translates. The server's `reason` is an English sentence and the
 * import history printed it after "Lý do:"; a Vietnamese operator read half the
 * row in English.
 *
 * - `field_user_edited` — a person edited the field after an earlier import;
 *   the import keeps the person's value.
 * - `basis_not_declared` — a coded basis while no installed framework declares
 *   any basis at all.
 * - `basis_required` — the record type needs a basis and the form gave none.
 * - `basis_needs_person` — only an authenticated person may record or change
 *   this basis (R-41).
 * - `basis_statement_rules` — the value is neither a declared option nor a
 *   ground with the article it rests on.
 * - `unknown` — any other refusal; the client says the value was not applied.
 */
export const REGISTRY_IMPORT_CONFLICT_REASON_CODES = [
    'field_user_edited',
    'basis_not_declared',
    'basis_required',
    'basis_needs_person',
    'basis_statement_rules',
    'unknown',
];
//# sourceMappingURL=data-registry.js.map